import React, { memo } from 'react'
import { BrowserRouter as Router, Routes, Route,Navigate } from 'react-router-dom';
import Home from './page/Home'
export default memo(function App() {
  return (
    <div>
              <Router>
            <Routes>
                <Route path="/"  element={<Navigate to="/redirect" />} />
                <Route path="/redirect" element={<Home />} />
            </Routes>
        </Router>
    </div>
  )
})
